import React, { PureComponent } from 'react';
import autobind from 'autobind-decorator';
import styled, { css } from 'styled-components';
/* Important because Foundation */
/* min-width because of flex bug on Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1088586 */
const StyledInput = styled.input`
  margin: 0 !important;
  border-radius: 3px !important;
  box-shadow: none !important;
  min-width: 0;
  -moz-appearance: textfield !important;

  ${({ isValid, theme, hasSuffix }) => css`
    ${isValid === false &&
      css`
        && {
          // this && creates extra !importance
          border-color: ${theme.colors.borderError} !important;
        }
      `}
    ${hasSuffix &&
      css`
        margin-right: 8px !important;
      `}
  `}

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  ${StyledInput} {
    flex: 1 1 auto;
  }
`;

// TODO create helper regexs @kerryaustin
// /^[0-9]+\.?[0-9]{0,2}?$/ 99[].99]

class Input extends PureComponent {
  state = {
    isValid: null,
  };

  @autobind
  onKeyDown(e) {
    const { onKeyDown, onEnter } = this.props;
    if (onEnter && (e.which == 13 || e.keyCode == 13)) onEnter(e);
    if (onKeyDown) onKeyDown(e);
  }

  @autobind
  onChange(event) {
    const { pattern, value, onChange } = this.props;
    if (pattern && event.target.value.length > 0) {
      if (!pattern.test(event.target.value)) {
        event.target.value = value;
      }
    }

    if (onChange) {
      onChange(event);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.validator && this.props.value !== nextProps.value) {
      this.validate(nextProps.validator, nextProps.value);
    }
    const { isValid } = nextProps;
    if (isValid !== null && isValid !== undefined) {
      this.setState({ isValid: nextProps.isValid });
    }
  }

  validate(validator, value) {
    const isValid = validator(value);
    this.setState({ isValid });
  }

  render() {
    const {
      onChange,
      pattern,
      value,
      onKeyDown,
      onEnter,
      inputRef,
      suffix,
      ...rest
    } = this.props;
    const input = (
      <StyledInput
        {...rest}
        innerRef={inputRef}
        value={value}
        onChange={this.onChange}
        onKeyDown={(onEnter || onKeyDown) && this.onKeyDown}
        isValid={this.state.isValid}
        hasSuffix={!!suffix}
      />
    );

    if (suffix) {
      return (
        <InputContainer>
          {input}
          {typeof suffix === 'string' ? <span>{suffix}</span> : suffix}
        </InputContainer>
      );
    }

    return input;
  }
}

export default Input;
